export const API_URL = "https://mapi2.3sigmacrm.com/";
// export const API_URL = 'http://65.2.40.36:5000/';
export const APP_VERSION = "2.4.0";
export const SOCKET_API_URL = "https://mapi2.3sigmacrm.com/";
export const BASE_API_URL = "https://mapi2.3sigmacrm.com/api/v1";

